import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { ExclamationCircleIcon } from '@heroicons/react/16/solid'

export default function TwInputGroup(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "", variant = "primary", } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.outerClassName
  if (inputProps.type !== undefined && inputProps.type == "number") {
    inputProps.lang = "en";
  }
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }
  if (inputProps.disabled && inputProps.disabled !== undefined) {
    inputClass += " !bg-gray-200"
  }
  if (inputProps.inputClass && inputProps.inputClass !== undefined) {
    inputClass += ` ${inputProps.inputClass}`
    delete inputProps.inputClass
  }
  let variantColor = ""
  if (variant === "primary") {
    variantColor = "px-4 md:px-5 rounded-2xl outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2"
  }
  if (variant === "line") {
    variantColor = "px-0 border-b-0 border-gray-300 hover:border-indigo-bz hover:bg-form focus-within:bg-form"
  }


  return (
    // <div className="sm:w-full sm:max-w-sm md:max-w-lg">
    <div className={classNames("w-full sm:w-full sm:max-w-sm md:max-w-lg", props.outerClassName)}>
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className={label ? "mt-2" : ""}>
        <div className={classNames("flex items-center [bg-input-bz] bg-white ", variantColor, inputClass)}>
          {leftIcon != undefined && (
            <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6">{leftIcon}</div>
          )}
          <input
            lang="en"
            {...inputProps}
            aria-invalid={props.error ? "true" : ""}
            aria-describedby={props.error ? "email-error" : ""}
            className={classNames("bg-transparent block min-w-0 grow py-5 pl-3 md:py-5 md:pl-5 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6 disabled:bg-gray-200",
              props.error ? "pr-3" : "pr-0",
              className
            )}
          />
          {rightIcon && (
            <div className="[size-5] bg-transparent">{rightIcon}</div>
          )}
          {props.error && (<ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />)}
        </div>
      </div>
      {props?.helperText != undefined && (<p className="mt-2 text-sm text-gray-400">
        {props.helperText}
      </p>)}
      {props.error && (<p className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
